<template>
  <div>
    <el-row>
      <el-col>
        <el-form ref="searchForm" :model="searchForm" :inline="true" size="medium" label-suffix="：">
          <el-form-item label="日期">
            <el-date-picker :picker-options="pickerOptions" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期" :clearable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doScreen()">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="doDownload()">下载</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="门店"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="减单数量"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import { doDownloadFun } from '@/assets/api/sellOrder';

export default {
  data() {
    return {
      PAGE_ID: '10409', // 页面ID 一旦规定不要轻易改动
      fun_dic: {}, // 功能ID 一旦规定不要轻易改动
      value1: '',
      searchForm: {
        SEND_DAY: date(new Date().getTime() + 3600 * 1000 * 24, '%F'),
      },
      pickerOptions: {},
      tableData: [],
    };
  },
  methods: {
    doScreen() {
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '10174',
        OTYPE: 2,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    doDownload() {
      if (this.tableData.length === 0) {
        this.$message.show({ text: '暂无数据', type: 'warning' });
        return false;
      }
      const params = {
        OMS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      doDownloadFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/sellOrderManage/reducedOrder.vue